import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import AssistantTestChatFab from './AssistantTestChatFab';
import navConfig from './nav/config-navigation';
import { RootState } from '../../redux/store';
import { isDashboardLocked, navigationForDashboardState } from '../../auth/dashboardAccess';
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();
  const user = useSelector((state: RootState) => state.auth.userReturn);
  const dashboardLocked = isDashboardLocked(user);
  const navigation = navigationForDashboardState(
    navConfig,
    dashboardLocked,
    PATH_DASHBOARD.general.home
  );

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = (
    <NavVertical data={navigation} openNav={open} onCloseNav={handleClose} />
  );

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal data={navigation} /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>

        {!dashboardLocked && <AssistantTestChatFab />}
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini data={navigation} /> : renderNavVertical}

          <Main>
            <Outlet />
          </Main>
        </Box>

        {!dashboardLocked && <AssistantTestChatFab />}
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>

      {!dashboardLocked && <AssistantTestChatFab />}
    </>
  );
}
